import React from "react";
import { Image, Badge } from "react-bootstrap";

const AVATAR_SIZE = 64;

// Right-most column in Stage 1 and Stage 2. Renders a mini-profile of
// whichever row is currently focused. Empty state when no row focused.
export default function DetailPane({ candidate }) {
  if (!candidate) {
    // Transparent container that fills the sidebar column so the prompt
    // sits visually centered — not in a white card. Inherits the modal
    // body's bg-body-secondary behind it.
    return (
      <div
        className="d-flex align-items-center justify-content-center text-center text-muted small p-4"
        style={{ height: "100%" }}
      >
        Pick a media person to see details
      </div>
    );
  }

  const {
    name,
    email,
    workplace,
    title,
    headline,
    bio,
    last_active_at: lastActiveAt,
    profile_image_url: profileImageUrl,
    is_stub: isStub,
    source,
  } = candidate;

  if (isStub) {
    return (
      <div className="p-3 bg-white">
        <div className="text-muted small">User no longer exists in the system.</div>
        <div className="small mt-2">
          ID: <code>{candidate.id}</code>
        </div>
        <Badge bg="warning" text="dark" className="mt-2">
          Remove to save
        </Badge>
      </div>
    );
  }

  return (
    <div className="p-3 bg-white">
      <div className="d-flex gap-3 align-items-start mb-3">
        {profileImageUrl && (
          <Image
            roundedCircle
            src={profileImageUrl}
            alt=""
            style={{ width: AVATAR_SIZE, height: AVATAR_SIZE, objectFit: "cover", flexShrink: 0 }}
          />
        )}
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="fw-semibold">{name}</div>
          {title && <div className="text-muted small">{title}</div>}
          {workplace && <div className="text-muted small">{workplace}</div>}
        </div>
      </div>

      {headline && (
        <div className="mb-3">
          <div className="text-muted small text-uppercase">Headline</div>
          <div>{headline}</div>
        </div>
      )}

      {bio && (
        <div className="mb-3">
          <div className="text-muted small text-uppercase">Bio</div>
          <div style={{ whiteSpace: "pre-wrap" }}>{bio}</div>
        </div>
      )}

      {email && (
        <div className="mb-3">
          <div className="text-muted small text-uppercase">Email</div>
          <div className="small">
            <code>{email}</code>
          </div>
        </div>
      )}

      {lastActiveAt && (
        <div className="mb-3">
          <div className="text-muted small text-uppercase">Last active</div>
          <div className="small">{new Date(lastActiveAt).toLocaleDateString()}</div>
        </div>
      )}

      {source && (
        <div className="mb-3">
          <div className="text-muted small text-uppercase">Added via</div>
          <div className="small">
            <Badge bg="secondary">{source.type}</Badge>
            {source.params?.query && <span className="ms-2 text-muted">&quot;{source.params.query}&quot;</span>}
            {source.params?.outlet_name && <span className="ms-2 text-muted">{source.params.outlet_name}</span>}
          </div>
        </div>
      )}
    </div>
  );
}
